module.exports = __webpack_public_path__ + "img/del.22e15712.png";